<div class="feedback-modal" [class.is-active]="showFeedbackModal$ | async">
  <div class="modal-backdrop" (click)="onCloseFeedbackModal()"></div>
  <div class="modal-container">
    <div class="feedback-card">
      <button class="close-button" (click)="onCloseFeedbackModal()" aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>

      @if (!showFeedbackGreeting) {
      <div class="feedback-content">
        <div class="feedback-header">
          <div class="feedback-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1H5C3.89 1 3 1.89 3 3V19C3 20.1 3.9 21 5 21H11V19H5V3H13V9H21ZM20.5 18.08L19.42 19.16L16.5 16.25L17.58 15.17L20.5 18.08ZM22.54 16.88L21.46 15.8L20.38 16.88L21.46 17.96L22.54 16.88ZM15.04 17.71L15.45 21.58L19.32 21.17L15.04 17.71Z"
                fill="currentColor" />
            </svg>
          </div>
          <h1 class="feedback-title">{{ 'RATING.FEEDBACK_MATTERS' | translate }}</h1>
          <p class="feedback-subtitle">{{ 'RATING.MOMENT_TO_RATE' | translate }}</p>
        </div>

        <form [formGroup]="feedbackForm" class="feedback-form">
          <div class="form-group">
            <mat-form-field appearance="outline" class="feedback-textarea">
              <mat-label>{{'RATING.FEEDBACK' |translate}}</mat-label>
              <textarea
                matInput
                [placeholder]="'RATING.PLACEHOLDER'|translate"
                formControlName="feedback"
                rows="4"
                class="custom-textarea"></textarea>
            </mat-form-field>
          </div>

          <div class="button-group">
            <button class="btn btn-secondary" type="button" (click)="onCloseFeedbackModal()">
              {{ 'RATING.NOT_NOW' | translate }}
            </button>
            <button class="btn btn-primary" type="button" [disabled]="!feedbackForm.valid" (click)="onSubmit()">
              <span class="btn-text">{{ 'SEND' | translate }}</span>
              <svg
                class="btn-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" fill="currentColor" />
              </svg>
            </button>
          </div>
        </form>
      </div>
      } @if (showFeedbackGreeting) {
      <div class="success-content">
        <div class="success-animation">
          <ng-lottie [styles]="animationStyles" containerClass="lottie-container" [options]="animationOptions">
          </ng-lottie>
        </div>
        <h1 class="success-title">{{ 'RATING.THANK_YOU' | translate }}</h1>
        <button class="btn btn-primary btn-full" (click)="onCloseFeedbackModal()">{{ 'CLOSE' | translate }}</button>
      </div>
      }
    </div>
  </div>
</div>
